'use client';

import { ReactNode } from 'react';
import { Box, Stack } from '@mui/material';
import DomainCheckWarning from '@/containers/auth/components/DomainCheckWarning';
type AuthLayoutProps = {
  children: ReactNode;
};
export default function AuthLayout({
  children
}: AuthLayoutProps): JSX.Element {
  return <Stack sx={{
    flexDirection: 'row',
    height: '100vh'
  }} data-sentry-element="Stack" data-sentry-component="AuthLayout" data-sentry-source-file="AuthLayout.tsx">
      <Stack sx={{
      flex: 1,
      bgcolor: '#fff',
      position: 'relative',
      overflow: 'auto',
      pb: '72px'
    }} data-sentry-element="Stack" data-sentry-source-file="AuthLayout.tsx">
        {children}
        <DomainCheckWarning data-sentry-element="DomainCheckWarning" data-sentry-source-file="AuthLayout.tsx" />
      </Stack>
      <Box sx={{
      flex: 1.3,
      display: {
        md: 'initial',
        xs: 'none'
      },
      backgroundColor: '#00061E',
      backgroundImage: 'url(/images/auth/background.jpg)',
      backgroundSize: 'auto 100%',
      backgroundPosition: 'center center',
      backgroundRepeat: 'no-repeat'
    }} data-sentry-element="Box" data-sentry-source-file="AuthLayout.tsx" />
    </Stack>;
}